import script from "./ABSIndividualViolationActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ABSIndividualViolationActions.vue?vue&type=script&setup=true&lang=js"

import "./ABSIndividualViolationActions.vue?vue&type=style&index=0&id=37466e4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37466e4f"]])

export default __exports__